import { render, staticRenderFns } from "./pointschangedlog.vue?vue&type=template&id=fd6549a0&"
import script from "./pointschangedlog.vue?vue&type=script&lang=js&"
export * from "./pointschangedlog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports